import api from './api';

const NotificationService = {
  getMyNotifications: (params) => api.get('/notifications', { params }),
  getUnreadCount: () => api.get('/notifications/unread-count'),
  markRead: (id) => api.post(`/notifications/${id}/read`),
  markAllRead: () => api.post('/notifications/read-all'),

  // Admin
  sendBulk: (data) => api.post('/notifications/bulk', data),
  getAllSent: (params) => api.get('/notifications/sent', { params }),
};

export default NotificationService;
